var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"es-container",on:{"mouseover":_vm.didHoverMarquee,"mouseleave":_vm.didLeaveMarquee}},[_c('marquee-text',{attrs:{"paused":_vm.isPaused,"duration":_vm.duration}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }